"use client";

import dynamic from "next/dynamic";
import SquareShimmer from "@/components/ui/shimmerUi/SquareShimmer";

/**
 * Client-only dynamic wrapper around `TestimonialCrouselMain`.
 *
 * `TestimonialCrouselMain` brings in Swiper + the testimonial card runtime — a
 * non-trivial chunk used in a section that lives below the LCP fold on every
 * treatment route. Wrapping it in `dynamic({ ssr: false })` from a tiny client
 * boundary splits that runtime into a separate chunk fetched/parsed AFTER
 * initial hydration, dropping the parent route's TBT.
 *
 * The shimmer reserves a stable height to keep CLS negligible.
 */
const TestimonialCrouselMain = dynamic(
  () => import("./TestimonialCrouselMain"),
  {
    ssr: false,
    loading: () => (
      <div className="h-[400px] md:h-[460px] w-full">
        <SquareShimmer />
      </div>
    ),
  }
);

export default TestimonialCrouselMain;
